import { useCallback, useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useControlStore } from '@editor/stores'
import { MarqueeSelectionListener } from './useEmitMarqueeSelectionListener'

const defaultOptions: { enabled: boolean } = {
  enabled: true,
}

const useMarqueeSelectionListener = (
  callback: MarqueeSelectionListener,
  options: {
    enabled: boolean
  } = defaultOptions,
) => {
  const addMarqueeSelectionListener = useControlStore(state => state.addMarqueeSelectionListener)
  const removeMarqueeSelectionListener = useControlStore(
    state => state.removeMarqueeSelectionListener,
  )

  const addListener = useCallback(
    (id: string, listener: MarqueeSelectionListener, enabled: boolean) => {
      addMarqueeSelectionListener(id, listener, enabled)
    },
    [addMarqueeSelectionListener],
  )

  const removeListener = useCallback(
    (id: string) => {
      removeMarqueeSelectionListener(id)
    },
    [removeMarqueeSelectionListener],
  )

  useLayoutEffect(() => {
    const id = v4()

    addListener(id, callback, options.enabled)
    return () => removeListener(id)
  }, [addListener, callback, options.enabled, removeListener])
}

export default useMarqueeSelectionListener
